module.exports = __webpack_public_path__ + "static/media/cat4.f12d0f5f.jpeg";